import {
    Component,
    HostBinding,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";

@Component({
    selector: "rask-span",
    templateUrl: "./span.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./span.component.scss"]
})
export class SpanComponent implements OnInit {
    @HostBinding("class") labelClass: string;
    @Input() size = "1";

    ngOnInit(): void {
        this.initSize();
    }

    initSize() {
        this.labelClass = `col-lg-${this.size}`;
    }
}
